module.exports = __webpack_public_path__ + "static/media/logo-company-tc.a6e2d009.png";